module.exports = __webpack_public_path__ + "img/img_process_big.09fd7c0a.png";